import { Injectable } from '@angular/core';

import { PouchdbService } from '../shared/pouchDb.service'
import { ShelfValues, bookCategoeyEnums } from '../shared/models/shelfEnums';
import { Book } from '../shared/models/book';

@Injectable()
export class AlbumPouchDb {
    localDB; remoteDB; storecompThis; bookTypes; subBooksStore;

    constructor(public pouchService: PouchdbService) {
        this.localDB = pouchService.localDB

    }
    ngOnInit() {

    }
    createdAlbumDataId;
    createAlbum(doc, albThis) {

        var self = this;

        self.createdAlbumDataId = doc._id;


        // doc._id = Math.floor(Date.now() / 1000);
        // doc._id = doc._id +"abc"
        this.pouchService.localDB.put(doc).then(function (result) {




            self.pouchService.localDB.find({
                selector: { type: 'book', _id: albThis.pdfObj._id },
            }).then(function (res) {
                res.docs[0].bookDataDocId = doc._id;
                if (albThis.tempUrl.length != 0) {
                    res.docs[0].coverPage = albThis.tempUrl[0];
                }
                else {
                    res.docs[0].coverPage = '';
                }
                return self.pouchService.localDB.put(res.docs[0]).then(function (response) {

                    self.pouchService.localDB.find({
                        selector: { type: 'albumData', _id: self.createdAlbumDataId },
                    }).then(function (response) {

                        albThis.loadImages(response);

                    }).catch(function (err) {
                        console.log(err);
                    });


                }).catch(function (err) {
                    console.log(err);
                });
            }).catch(function (err) {
                console.log(err);
            });




        }).catch(function (err) {

        })

    }

    getAlbData(albThis) {

        var self = this;

        self.pouchService.localDB.find({
            selector: { type: 'albumData', _id: albThis.pdfObj.bookDataDocId },
        }).then(function (res) {
            if (res == undefined) {
                // albThis.loadImages(res);

            }
            else {

                albThis.cdr.detectChanges();
                albThis.loadInitialImages(res);


            }


        })

        //     var self = this;

        //     self.createdAlbumDataId = doc._id;

        //     db.get('mydoc').then(function(doc) {
        //         return db.put({
        //           _id: 'mydoc',
        //           _rev: doc._rev,
        //           title: "Let's Dance"
        //         });
        //       }).then(function(response) {
        //         // handle response
        //       }).catch(function (err) {
        //         console.log(err);
        //       });


    }
    updateAlbData(albThis) {
        var self = this;

        // self.createdAlbumDataId = doc._id;


        // // doc._id = Math.floor(Date.now() / 1000);
        // // doc._id = doc._id +"abc"
        // this.pouchService.localDB.put(doc).then(function (result) {

        self.pouchService.localDB.find({
            selector: { type: 'book', _id: albThis.pdfObj._id },
        }).then(function (res) {

            res.docs[0].coverPage = albThis.tempUrl[0];

            return self.pouchService.localDB.put(res.docs[0]).then(function (response) {




                self.pouchService.localDB.find({
                    selector: { type: 'albumData', _id: albThis.pdfObj.bookDataDocId },
                }).then(function (res) {


                    res.docs[0].imageUrls = albThis.tempUrl;


                    return self.pouchService.localDB.put(res.docs[0]).then(function (response) {



                        self.pouchService.localDB.find({
                            selector: { type: 'albumData', _id: albThis.pdfObj.bookDataDocId },
                        }).then(function (res) {

                            albThis.loadImages(res);

                        })


                    }).catch(function (err) {
                        console.log(err);
                    });
                }).catch(function (err) {
                    console.log(err);
                });
            })
        })




        //    })



    }


}


// WEBPACK FOOTER //
// ./src/app/album/album.pouchService.ts